import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InputTelefoneCelular } from "app/components/inputs/InputTelefoneCelular";
import { SelecaoComFiltro } from "app/components/selecao-com-filtro/SelecaoComFiltro";
import { Separador } from "app/components/separador/Separador";
import { Vendedor } from "app/types/Vendedor";
import { FormikErrors, useFormik } from "formik";
import globalMU from "globalMU";
import * as R from 'ramda';
import React, { useEffect, useState } from "react";

const estiloInputs = require('../../../estilos/inputs.module.scss').default
const estiloBotoes = require('../../../estilos/botoes.module.scss').default

export type Atividade = {
    Codigo: string;
    Descricao: string;
    UserMessage?: string;
    Transforming: boolean;
}

export type Motivo = {
    Codigo: string;
    Nome: string;
    Descricao: string;
    UserMessage?: string;
    Transforming: boolean;
}


export type DadosAtividades = {
    EntitiesAtividade: Atividade[];
}

export type CadastroAtendimento = {
    Codigo?: string;
    Data?: string;
    CodigoAtividade?: string;
    CodigoCliente?: number;
    CodigoMotivo?: string;
    CodigoVendedor?: string;
    NomeVendedor?: string;
    Contato?: string;
    DataProximoContato?: string;
    NomeCliente?: string;
    NumeroPedido?: number;
    Telefone?: string;
    Texto?: string;
    PermitidoAlterarCliente?: boolean;
}

export type CadastrarAtendimentoProps = {
    dadosCadastrarAtendimento: CadastroAtendimento;
    atividades: Atividade[];
    motivos: Motivo[];
    vendedores: Vendedor[]
    possuiCliente: boolean
    onPesquisarVendedor: (nome: string) => void;
    onSalvar: (onSalvarProps: CadastroAtendimento) => void;
    onPesquisarMotivos: (descricao: string) => void;
    onPesquisarAtividades: (descricao: string) => void;
    onErrorValidacao: (erros: FormikErrors<CadastroAtendimento>) => void
    onPesquisarCliente: (cadastroAtendimento: CadastroAtendimento) => void
    onLimparCliente: () => void
}

export const CadastrarAtendimento = (props: CadastrarAtendimentoProps) => {
    const [formularioValidado, setFormularioValidado] = useState<boolean>(false)
    const [carregandoVendedor, setCarregadoVendedor] = useState(false)
    const [carregandoAtividade, setCarregandoAtividade] = useState(false)
    const [carregandoMotivo, setCarregandoMotivo] = useState(false)

    const formik = useFormik({
        initialValues: { ...props.dadosCadastrarAtendimento },
        onSubmit: (values, { }) => { },
        enableReinitialize: true,
        validate: (values) => {

            const mensagemObrigatorio = (campo) => `O campo "${campo}" é obrigatório.`
            const mensagemDataMenor = (campo: string) => `O campo  "${campo}" não pode ser maior do que a a data/hora atual".`

            return R.pickBy(value => globalMU.isNotNullOrEmpty(value), {
                CodigoCliente: globalMU.isNullOrEmptyOrZero(values.CodigoCliente) ? mensagemObrigatorio("Cliente") : undefined,
                CodigoMotivo: globalMU.isNullOrEmptyOrZero(Number(values.CodigoMotivo)) ? mensagemObrigatorio("Motivo") : undefined,
                CodigoAtividade: globalMU.isNullOrEmptyOrZero(Number(values.CodigoAtividade)) ? mensagemObrigatorio("Atividade") : undefined,
                DataProximoContato: globalMU.toDate(values.DataProximoContato,"YYYY-MM-DD HH:mm") < globalMU.toDate(values.Data,"dd/MM/yyyy") ? mensagemDataMenor("Data Próx. Contato") : undefined,
            } as FormikErrors<CadastroAtendimento>)
        }
    });

    useEffect(() => {
        setCarregadoVendedor(false)
    }, [props.vendedores])

    useEffect(() => {
        setCarregandoAtividade(false)
    }, [props.atividades])

    useEffect(() => {
        setCarregandoMotivo(false)
    }, [props.motivos])


    return (
        <>
            <Separador />

            <div className="mt-[30px]"
                id="CadastrarAtendimento_Dados"
            >

                {props?.dadosCadastrarAtendimento?.NumeroPedido > 7 && (
                  <div className="_flex _my-2">
                      <label className={`_w-[160px] _text-right _font-normal _mb-0 _mr-3 ${estiloInputs.labelObrigatorio}`}>
                         Orçamento
                     </label>
                     <input
                         id="CadastrarAtendimento_NumeroPedido"
                         className="_w-[280px]"
                         type="text"
                         value={(props.dadosCadastrarAtendimento.NumeroPedido) ?? ""}
                         readOnly
                         disabled
                     />
                 </div>
                )}
          

                <div className="_flex _my-2">
                    <label className={`_w-[160px] _text-right _font-normal _mb-0 _mr-3 ${estiloInputs.labelObrigatorio}`}
                    >
                        Cliente</label>
                    <input
                        id="CadastrarAtendimento_NomeCliente"
                        className={`_w-[280px] ${formularioValidado && formik.errors.CodigoCliente != undefined && estiloInputs.inputComErro}`}
                        name="NomeCliente" type="text" value={formik.values.NomeCliente ?? ''}
                        readOnly
                        disabled // sempre fica desabilitad
                        title="Clique na lupa para pesquisar o cliente"
                        placeholder="Clique na lupa para pesquisar"

                    />

                    {props.possuiCliente && (
                        <>
                            <FontAwesomeIcon
                                id="CadastrarAtendimento_BotaoPesquisarCliente"
                                className="material-icons _mx-3 _w-[18px] _cursor-pointer _text-[#3c8ac9]"
                                icon={faSearch}
                                onClick={() => props.onPesquisarCliente(formik.values)}
                            />
                            <FontAwesomeIcon
                                id="CadastrarAtendimento_BotaoLimparCliente"    
                                className="material-icons _w-[18px] _cursor-pointer _text-[#f25713]"
                                icon={faTimesCircle}
                                onClick={() => {
                                    formik.setFieldValue("NomeCliente", "")
                                    props.onLimparCliente()
                                }}
                            />
                        </>
                    )}

                </div>

                <div className="_flex _my-2"
                    id="CadastrarAtendimento_Data"
                >
                    <label className="_w-[160px] _text-right _font-normal _mb-0 _mr-3">Data</label>
                    <input className="_w-[200px]" type="text" readOnly disabled value={formik.values.Data ?? ''} 
                        id="CadastrarAtendimento_DataInput"
                    />
                </div>


                <div className="_flex _my-2">
                    <label className="_w-[160px] _text-right _font-normal _mb-0 _mr-3">Vendedor</label>

                    <SelecaoComFiltro
                        id="CadastrarAtendimento_Vendedor"
                        classNameIconeSeta="_w-[10px] _text-gray-500 _mr-[4px]"
                        classNameInput="_w-[200px]"
                        itens={carregandoVendedor ? [{ chave: "", valor: "Buscando..." }] : (props.vendedores ?? []).map(vendedor => ({
                            chave: vendedor.Codigo.toString(),
                            valor: vendedor.Nome
                        }))}
                        onValorModificado={(vendedor) => (setCarregadoVendedor(true), props.onPesquisarVendedor(vendedor))}
                        onItemSelecionado={item => {
                            formik.setFieldValue("CodigoVendedor", (props?.vendedores ?? []).find(b => b.Codigo.toString() == item.chave)?.Codigo.toString())
                            formik.setFieldValue("NomeVendedor", (props?.vendedores ?? []).find(b => b.Codigo.toString() == item.chave)?.Nome)
                        }}
                        itemSelecionado={{
                            chave: formik.values.CodigoVendedor,
                            valor: formik.values.NomeVendedor
                        }}
                        disabled={props.dadosCadastrarAtendimento?.CodigoVendedor != null}
                        onLimpar={() => {
                            formik.setFieldValue("CodigoVendedor", null)
                            formik.setFieldValue("NomeVendedor", null)
                        }}
                        exibirIconeLimpar={props.dadosCadastrarAtendimento?.CodigoVendedor == null}
                        filtroManual={true}
                        placeholder="Digite 1 ou mais caracteres"
                    />
                </div>

                <div className="_flex _my-2"
                    id="CadastrarAtendimento_Atividade"
                >
                    <label className={`_w-[160px] _text-right _font-normal _mb-0 _mr-3 ${estiloInputs.labelObrigatorio}`}>Atividade</label>

                    <SelecaoComFiltro
                        id="CadastrarAtendimento_AtividadeSelecao"
                        classNameIconeSeta="_w-[10px] _text-gray-500 _mr-[4px]"
                        classNameInput={`_w-[200px] ${formularioValidado && formik.errors.CodigoAtividade != undefined && estiloInputs.inputComErro}`}
                        itens={carregandoAtividade ? [{ chave: "", valor: "Buscando..." }] : (props.atividades ?? []).map(atividade => ({
                            chave: atividade.Codigo.toString(),
                            valor: atividade.Descricao
                        }))}
                        onValorModificado={(atividade) => (setCarregandoAtividade(true), props.onPesquisarAtividades(atividade))}
                        onItemSelecionado={item => {
                            formik.setFieldValue("CodigoAtividade", (props?.atividades ?? []).find(b => b.Codigo.toString() == item.chave)?.Codigo.toString())
                        }}
                        itemSelecionado={{
                            chave: formik.values.CodigoAtividade,
                            valor: (props?.atividades ?? []).find(b => b.Codigo.toString() == formik.values.CodigoAtividade)?.Descricao
                        }}
                        onLimpar={() => formik.setFieldValue("CodigoAtividade", null)}
                        exibirIconeLimpar={true}
                        filtroManual={true}
                        placeholder="Digite 1 ou mais caracteres"
                    />
                </div >

                <div className="_flex _my-2">
                    <label className={`_w-[160px] _text-right _font-normal _mb-0 _mr-3 ${estiloInputs.labelObrigatorio}`}>Motivo</label>

                    <SelecaoComFiltro
                        id="CadastrarAtendimento_MotivoSelecao"
                        classNameIconeSeta="_w-[10px] _text-gray-500 _mr-[4px]"
                        classNameInput={`_w-[200px] ${formularioValidado && formik.errors.CodigoMotivo != undefined && estiloInputs.inputComErro}`}
                        itens={carregandoMotivo ? [{ chave: "", valor: "Buscando..." }] : (props.motivos ?? []).map(motivo => ({
                            chave: motivo.Codigo.toString(),
                            valor: motivo.Nome
                        }))}
                        onValorModificado={(motivo) => (setCarregandoMotivo(true), props.onPesquisarMotivos(motivo))}
                        onItemSelecionado={item => {
                            formik.setFieldValue("CodigoMotivo", (props?.motivos ?? []).find(b => b.Codigo.toString() == item.chave)?.Codigo.toString())
                        }}
                        itemSelecionado={{
                            chave: formik.values.CodigoMotivo,
                            valor: (props?.motivos ?? []).find(b => b.Codigo.toString() == formik.values.CodigoMotivo)?.Nome
                        }}
                        onLimpar={() => formik.setFieldValue("CodigoMotivo", null)}
                        exibirIconeLimpar={true}
                        filtroManual={true}
                        placeholder="Digite 1 ou mais caracteres"
                    />
                </div>

                <div className="_flex _my-2">
                    <label className="_w-[160px] _text-right _font-normal _mb-0 _mr-3">Contato</label>
                    <input className="_w-[200px]" type="text" name="Contato" onChange={formik.handleChange} value={formik.values.Contato ?? ''} maxLength={20}
                         id="CadastrarAtendimento_ContatoInput"
                    />
                </div>

                <div className="_flex _my-2">
                    <label className="_w-[160px] _text-right _font-normal _mb-0 _mr-3">Telefone</label>

                    <InputTelefoneCelular
                        className="_w-[200px]"
                        telefoneCelular={formik.values.Telefone}
                        onTelefoneCelularModificado={(telfone) => formik.setFieldValue("Telefone", telfone)}
                        id="CadastrarAtendimento_TelefoneInput"
                    />
                </div>

                <div className="_flex _my-2">
                    <label className="_w-[160px] _text-right _font-normal _mb-0 _mr-3">Data Próx. Contato</label>
                    <input
                        className={`_w-[200px] ${formularioValidado && formik.errors.DataProximoContato != undefined && estiloInputs.inputComErro}`}
                        type="datetime-local" name="DataProximoContato" value={formik.values.DataProximoContato ?? ''}
                        onChange={(e) => formik.setFieldValue("DataProximoContato", e.target.value)}
                        id="CadastrarAtendimento_DataProximoContatoInput"
                    />
                </div>

                <div className="_flex _my-2">
                    <label className="_w-[160px] _text-right _font-normal _mb-0 _mr-3">Texto</label>
                    <textarea className="_w-[360px]" rows={3} name="Texto" id="CadastrarAtendimento_TextoInput" onChange={formik.handleChange} maxLength={254} value={formik.values?.Texto ?? ''} />
                </div>
            </div>

            <button
                className={`no-global-button _mt-4 ${estiloBotoes.botaoPrimario}`}
                id="CadastrarAtendimento_SalvarButton"
                onClick={async () => {
                    const erros = await formik.validateForm(formik.values)

                    Object.keys(erros).length == 0 ? props.onSalvar(formik.values) : props.onErrorValidacao(erros)

                    setFormularioValidado(true)

                }}

            >
                Salvar
            </button>
        </>
    );
}